export const getStyles = () => {
    const styles = {
        forgotPassword: {
            display: "flex",
            justifyContent: "center",
            mt: 3,
        }
    };
    return styles;
}